import { Box, Button, ButtonGroup, Card, CardContent, DialogContent, FormControl, FormControlLabel, Grid, makeStyles, Switch, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { LocationForm } from 'components/AddressLocationForm/LocationForm';
import { MapBox } from 'components/AddressLocationForm/MapBox';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { filterNonNull, formatAddressObject } from 'util/format';
import { useTrackEvent, useTrackPage } from 'util/trackEvent';
import { ExistingLocations } from './ExistingLocations';
import ReactJson from 'react-json-view';
import { useGeolocation } from 'util/useGeolocation';
import { MyLocation } from '@material-ui/icons';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      alignSelf: 'center',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      paddingBottom: theme.spacing(4)
    },
    content: {
      lineHeight: '2em',
      paddingTop: theme.spacing(3),

    },
    dialogContent: {
      height: 'auto',
      flex: '0 0 auto'
    },
    action: {
      display: 'flex',

      flexDirection: 'row',
      justifyContent: 'center',
      paddingBottom: theme.spacing(2),
      "& > *": {
        '&:not(:first-child)': {
          marginLeft: '.5em'
        }
      }
    },
    reverseStack1: {
      order: 1,
      [theme.breakpoints.up('md')]: {
        order: 2
      }
    },
    reverseStack2: {
      order: 2,
      [theme.breakpoints.up('md')]: {
        order: 1
      }
    },
    reverseStack3: {
      textAlign: 'center',
      order: 3,
      [theme.breakpoints.up('md')]: {
        order: 3
      }
    },
    map: {
      position: 'relative',
    },
    mapLoc:{
      position: 'absolute',
      bottom: 0,
      right: 0,
    }
  }
})

const LocationEdit = ({
  sessionToken,
  altLayout = false,
  affirmLabel,
  existingLocations = [],
  forceRequireNewLocation = false,
  isEditing = false,
  onCancel,
  onSelectEdit = () => { },
  onSelectConfirm = () => { },
  onSelectExistingConfirm = () => { },
  onUpdateAddress = () => { },
  onOpenSupport = () => { },
  location: cLoc,
  requiresNewLocation,
  loading = false,
  dialogTitle = 'Confirm location',
  booking_id
}) => {
  const classes = useStyles()

  const trackEvent = useTrackEvent()
  const trackPage = useTrackPage()

  const [dirty, setDirty] = useState(false);
  const [mapDirty, setMapDirty] = useState(false);
  const [lngLat, setLngLat] = useState(
    { lat: cLoc?.latitude, lng: cLoc?.longitude }
  );

  const mapRef = useRef(null);

  const [isPresetLocation, setIsPresetLocation] = useState(false);
  const [cMarker, setCMarker] = useState(null);
  const [location, setLocation] = useState(cLoc);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedExistingLocation, setSelectedExistingLocation] = useState(null);

  const {
    dialog,
    error: geolocationError,
    isGeolocationEnabled,
    latLng: browserLatLng,
    fetchNewLocation
  } = useGeolocation({watchLocation: false});

  const updateMapFromGeolocation = useCallback(
    (browserLatLng) => {
      if (!browserLatLng?.lat || !browserLatLng?.lng) {
        return
      }
      trackEvent('Location Form - Use My Location ', { dialog: ['LocationConfirmDialog', 'LocationForm'] })
      setLocation({ latitude: browserLatLng?.lat, longitude: browserLatLng?.lng })
      mapRef?.current?.setCenter([browserLatLng?.lng, browserLatLng?.lat]);
      setLngLat(browserLatLng)
      setMapDirty(true)
    },
    [],
  );

  useEffect(
    () => {
      if (browserLatLng && !cLoc?.latitude && !cLoc?.longitude) {
        updateMapFromGeolocation(browserLatLng)
      }
    }, [browserLatLng, cLoc]
  );

  // useEffect(() => {
  //   setLocation(cLoc);
  //   setLngLat({ latitude: cLoc?.latitude, longitude: cLoc?.longitude })
  // }, [cLoc]);

  const doSubmitCallback = useCallback(
    (address, loc) => {
      const newLoc = filterNonNull({ latitude: lngLat?.lat, longitude: lngLat?.lng })
      const updatedLoc = { ...location, ...address, ...loc, ...newLoc, }
      console.log(lngLat)
      onUpdateAddress(updatedLoc)
      setLocation({ cLoc, ...updatedLoc })
      setDirty(true)
      setRefreshKey(Math.random())
      onSelectEdit(false)
    },
    [cLoc, onSelectEdit, onUpdateAddress, lngLat],
  );


  const resizeMemo = useCallback(
    () => {
      if (dirty) {
        mapRef?.current?.resize()
      }
    }, [dirty]
  );

  // useEffect(
  //   () => {

  //       mapRef?.current?.setCenter([cLoc?.longitude, cLoc?.latitude]);

  //   }, [mapRef?.current, cLoc?.latitude, cLoc?.longitude]
  // );

  const onSetMarker = useCallback(
    (mkr) => {
      setIsPresetLocation(false)
      setLngLat({ lat: mkr?.latitude, lng: mkr?.longitude })
      setCMarker(mkr);
      if (mapRef?.current && mkr?.latitude && mkr?.longitude) {
        mapRef?.current?.setCenter([mkr?.longitude, mkr?.latitude]);
      }
    },
    [],
  );
  const renderButtons = useMemo(
    () => {
      const hasCloc = cLoc?.newLocation
      const hasLoc = hasCloc
      return hasLoc ? <></> :
        (
          <Button disabled={loading} onClick={() => {
            trackEvent(`${dialogTitle} - Confirm `, { dialog: 'LocationConfirmDialog' })
            onSelectConfirm()
          }} variant="contained" color="primary">Confirm</Button>

        )
    }, [forceRequireNewLocation, cLoc, loading, dialogTitle]
  );

  const locFormRef = useRef();

  const renderAltLayoutButtons = useMemo(
    () => {
      if (altLayout) {
        return (
          <Grid item xs={12} className={classes.reverseStack3}>
            {onCancel && (
              <Button
                onClick={() => {
                  onCancel()
                }}
                variant="outlined"
                color="secondary"
              >Go Back</Button>
            )}
            {(locFormRef?.current || cLoc?.address) && (
              <Button
                // disabled={locFormRef?.current?.isSubmitDisabled()}
                onClick={() => {
                  locFormRef?.current?.submitForm()
                }}
                variant="contained" color="primary">{affirmLabel}</Button>
            )}
          </Grid>
        )
      } else if ((locFormRef?.current || cLoc?.address)) {
        <Grid item xs={12} className={classes.reverseStack3}>
          {onCancel && (
            <Button
              onClick={() => {
                onCancel()
              }}
              variant="outlined"
              color="secondary"
            >Go Back</Button>
          )}
          <Button
            // disabled={locFormRef?.current?.isSubmitDisabled()}
            onClick={() => {
              locFormRef?.current?.submitForm()
            }}
            variant="contained" color="primary">{affirmLabel}</Button>
        </Grid>
      }
      return <></>
    }, [locFormRef?.current, cLoc, altLayout, onCancel, affirmLabel]
  );
  return (
    <>
    {dialog}
    <Grid container spacing={2}>
      <Grid item xs={12} md={6} className={classes.reverseStack1}

      >
        {isEditing ? (
          <LocationForm
            sessionToken={sessionToken}
            ref={locFormRef}
            altLayout={altLayout}
            mapDirty={mapDirty}
            affirmLabel={affirmLabel || 'Update Location'}
            currentLocation={lngLat}
            locationObject={location}
            cancelCallback={() => {
              trackEvent('Location Form - Cancel ', { dialog: ['LocationConfirmDialog', 'LocationForm'] })
              onSelectEdit(false)
              setLngLat({ latitude: location?.latitude, longitude: location?.longitude })
              history.back()
              // if (mapRef?.current) {
              //   mapRef?.current?.setCenter([location?.longitude, location?.latitude]);
              // }
            }}
            onSubmitCallback={(address) => {
              const { latitude, longitude, ...restAddress } = address;
              doSubmitCallback(restAddress, { latitude, longitude })
              trackEvent('Location Form - Update Location ', { dialog: ['LocationConfirmDialog', 'LocationForm'], address, loc: { latitude, longitude } })
            }}
            onSetMarker={(mkr) => {
              onSetMarker(mkr)
            }}

          />
        ) :
          <>
            <DialogContent className={classes.dialogContent}>
              <Typography variant='h4'>
                {dialogTitle}
              </Typography>
            </DialogContent></>
        }

        {isEditing ? (<>
        </>) :
          (
            <>
              <CardContent>
                <FormControl>
                  <FormControlLabel label="Use Previous Booking Location" control={
                    <Switch checked={isPresetLocation} onChange={(e) => {
                      setIsPresetLocation(e.target.checked)
                    }} />
                  } />
                </FormControl>

              </CardContent>
              <CardContent>
                {isPresetLocation ? (
                  <>
                    <ExistingLocations
                      locations={existingLocations}
                      onSelect={(loc) => {
                        trackEvent('Location Form - Existing Location Selected ', { dialog: ['LocationConfirmDialog', 'LocationForm'], loc })
                        setLocation(loc)
                        setIsPresetLocation(true)
                        setSelectedExistingLocation(loc)
                        if (mapRef?.current && loc?.latitude && loc?.longitude) {
                          mapRef?.current?.setCenter([loc?.longitude, loc?.latitude]);
                        }
                      }}
                    />
                    {(!!selectedExistingLocation && isPresetLocation) && (
                      <Box className={classes.content} textAlign="center">
                        <Button disabled={loading} onClick={() => {
                          trackEvent(`${dialogTitle} - Existing Location Confirm `, { dialog: 'LocationConfirmDialog' })
                          onSelectExistingConfirm(location?.id)
                        }} variant="contained" color="primary">Confirm</Button>
                      </Box>
                    )}
                  </>

                ) :
                  (
                    <>
                      <Typography variant='body2'>
                        {!isPresetLocation && formatAddressObject(location)}
                      </Typography>

                      <div className={clsx(classes.content, classes.action)}>
                        <Button disabled={loading} onClick={() => {
                          trackEvent(`${dialogTitle} - Edit Address `, { dialog: 'LocationConfirmDialog' })
                          onSelectEdit(true)
                          setIsPresetLocation(false)
                        }} variant="outlined" color="primary">
                          {requiresNewLocation ? 'Set' : 'Edit'} Address
                        </Button>
                        {renderButtons}

                      </div>
                    </>
                  )}
              </CardContent>
            </>
          )}
      </Grid>
      <Grid item xs={12} md={6} className={classes.reverseStack2}
      >
        <Card className={classes.map}>
          <MapBox
            key={refreshKey}
            onRef={(ref) => {
              mapRef.current = ref
            }}
            style={{ height: '50vh' }}
            canvasDrag={isEditing}
            center={{ latitude: location?.latitude, longitude: location?.longitude }}
            markerLocation={{ latitude: location?.latitude, longitude: location?.longitude }}
            onMarkerDragEnd={(lnglat) => {
              trackEvent('Location Form - Pin Moved ', { dialog: ['LocationConfirmDialog', 'LocationForm'], lnglat })
              setLngLat(lnglat)
              setMapDirty(true)
            }}
          />
          <Button 
          variant="contained"
          color="secondary"
          className={classes.mapLoc} 
          startIcon={<MyLocation/>}
          onClick={async () => {
            const loc = await fetchNewLocation()
            updateMapFromGeolocation(loc)
            }} >Use My Location</Button>
        </Card>
      </Grid>
      {renderAltLayoutButtons}
    </Grid>
    </>
  )
}

export { LocationEdit };
